import { useEffect } from "react";
import { useMemo } from "react";
import { useState } from "react";

export default function useBranding() {
  const InitialState = window.Branding || {
    Id: 1,
    Name: "Exista Business Solutions LLC",
    CompanyName: "Exista Business Solutions LLC",
    Contact: {
      Phone: "tel:201015471713",
      WhatsApp: "https://wa.me/201148371185",
      FaceBook: "https://www.facebook.com/futuresolutionsdev",
    },
  };
  const [Branding, setBranding] = useState(InitialState);
  useEffect(() => {}, []);
  //   console.log("State : ", Branding);
  return useMemo(() => {
    const OnChange = (Key, Value) => {
      console.log({
        Key,
        Value,
      });
      if (typeof Key == "object") {
        setBranding((prev) => ({
          ...prev,
          ...Key,
        }));
        return;
      }
      setBranding((prev) => ({
        ...prev,
        [Key]: Value,
      }));
    };
    return { ...Branding, OnChange };
  }, [Branding]);
}
